<template>
    <Modal
        id="iban-verification-view-modal"
        ref="ibanVerificationViewModal"
        v-model:open="open"
        :title="$t('iban_verification_view')"
    >
        <div
            v-if="ibanVerification"
            class="flex h-auto w-full flex-col items-start justify-start space-y-3"
        >
            <div
                class="flex h-auto w-full items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-semibold">{{ $t('id') }}:</p>
                <p class="text-sm">{{ ibanVerification.id }}</p>
            </div>
            <div
                class="flex h-auto w-full items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-semibold">{{ $t('contract_uid') }}:</p>
                <p class="text-sm">{{ ibanVerification.contract_uid }}</p>
            </div>
            <div
                class="flex h-auto w-full items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-semibold">{{ $t('external_id') }}:</p>
                <p class="text-sm">{{ ibanVerification.external_id }}</p>
            </div>
            <div
                class="flex h-auto w-full items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-semibold">{{ $t('status') }}:</p>
                <p class="text-sm">{{ ibanVerification.status }}</p>
            </div>
            <div
                class="flex h-auto w-full flex-col items-start justify-start space-y-2 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-bold">{{ $t('data') }}:</p>
                <div
                    class="bg-primary-additional-50 flex h-auto w-full flex-col items-start justify-start rounded-md px-4 py-2 text-sm"
                >
                    <VueJsonPretty :data="ibanVerification.data" />
                </div>
            </div>
            <div
                class="flex h-auto w-full flex-col items-start justify-start space-y-2 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-bold">{{ $t('response_data') }}:</p>
                <div
                    class="bg-primary-additional-50 flex h-auto w-full flex-col items-start justify-start rounded-md px-4 py-2 text-sm"
                >
                    <VueJsonPretty :data="ibanVerification.response_data" />
                </div>
            </div>
            <div
                class="flex h-auto w-full items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-semibold">{{ $t('created_at') }}:</p>
                <p class="text-sm">
                    {{
                        moment(ibanVerification.created_at).format(
                            'DD.MM.yyyy HH:mm'
                        )
                    }}
                </p>
            </div>
            <div
                class="flex h-auto w-full items-start justify-start space-x-1 rounded-md bg-gray-100 px-4 py-2"
            >
                <p class="text-sm font-semibold">{{ $t('updated_at') }}:</p>
                <p class="text-sm">
                    {{
                        moment(ibanVerification.updated_at).format(
                            'DD.MM.yyyy HH:mm'
                        )
                    }}
                </p>
            </div>
        </div>
    </Modal>
</template>

<script setup lang="ts">
import Modal from '@src/components/Modal.vue'
import { IbanVerification } from '@src/types/IbanVerification'
import { useVModels } from '@vueuse/core'
import moment from 'moment'
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

const emit = defineEmits(['update:open'])

const props = defineProps<{
    ibanVerification: IbanVerification | null
    open: boolean
}>()

const { open } = useVModels(props, emit)
</script>
